import { React, useMemo } from 'react';
import { Card, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
// LOCAL
import { Doughnut } from 'react-chartjs-2';
import { formatVal } from "../../utils/string";

ChartJS.register(ArcElement, Tooltip, Legend);

/**
 * 
 * @param {String} title PieChart's title
 * @param {Object} data format --> { label: value, label: value }
 * @returns 
 */
function PieChart({ title, data, isCustom = false }) {
      // const theme = useTheme();

      // yelow, green, red,
      // const backgroundColor = ['#ffff80', '#80ff80', '#ff6666']
      const options = {
            responsive: true,
            plugins: {
                  legend: { position: 'none' },
            }
      }

      function getTotal(initData) {
            let total = 0;
            Object.entries(initData).map((d) => { total += d[1] })
            return total
      }

      function generateData(initData) {
            let label = [];
            let data = [];
            let backgroundColor = [];

            Object.entries(initData).map((d) => {
                  label.push(d[0]) // lable
                  data.push(d[1]) // values

                  // Assign background color based on status
                  switch (d[0]) {
                        case 'active':
                        case 'live':
                        backgroundColor.push('#74B569'); // green
                        break;
                        case 'inactive':
                        case 'total':
                        case 'registered':
                        backgroundColor.push('#B56969'); // red
                        break;
                        case 'draft':
                        backgroundColor.push('#BDBABB'); // gray
                        break;
                        case 'verifying':
                        case 'unverified':
                        backgroundColor.push('#F4CC64'); // yellow
                        break;
                        default:
                        backgroundColor.push('#000000'); // fallback color
                  }
            })

            const _data = {
                  labels: label,
                  datasets: [
                        {
                              data: data,
                              backgroundColor: backgroundColor,
                              borderWidth: 0,
                        },
                  ],
            };

            return _data
      }

      const subLabel = useMemo(() => {
            const currentDate = new Date();

            if (title === 'Monthly') {
                  const monthName = new Intl.DateTimeFormat('en', { month: 'short' }).format(currentDate);
                  return `( ${monthName} )`;
            }

            if (title === 'Quarterly') {
                  const currentMonth = currentDate.getMonth();
                  const startIdx = Math.floor(currentMonth / 3) * 3;
                  const endIdx = startIdx + 2;

                  const getMonthName = (idx) => 
                        new Intl.DateTimeFormat('en', { month: 'short' }).format(new Date(2000, idx));

                  return `( ${getMonthName(startIdx)} - ${getMonthName(endIdx)} )`;
            }

            if (title === 'Yearly') {
                  return `( ${currentDate.getFullYear()} )`;
            }

            return '';
      }, [title]);

      return (
            <Card sx={{ display: 'flex', flexDirection: 'row', width: '100%', height: 150, p: 4 }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                        <Typography variant='subtitle1' sx={{ fontWeight: 600, lineHeight: 1.2 }}>
                              {title} {subLabel}
                        </Typography>

                        {
                              getTotal(data) > 0
                                    ? <Typography sx={{ fontSize: '30px', fontWeight: 600 }}>{ isCustom ? formatVal(data.live, 'number') : formatVal(getTotal(data), 'number')}</Typography>
                                    : <Typography sx={{ fontSize: '15px', color: 'lightgray', fontWeight: 600, mt: 8 }}>{"Empty"}</Typography>
                        }
                  </Box>
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                        {
                              getTotal(data) > 0
                                    ? <Doughnut options={options} data={generateData(data)} />
                                    : <Box sx={{ background: '#E9E9E9', width: 118, height: 118, borderRadius: 100 }} />
                        }
                  </Box>
            </Card>
      );
}

export default PieChart; 